import { useEffect } from 'react';

export const useScrollIntoVisibleViewport = ({ paddingTop = 0, paddingBottom = 0 }) => {
  useEffect(() => {
    const html = document.documentElement;
    const prevScrollPaddingTop = html.style.scrollPaddingTop;
    const prevScrollPaddingBottom = html.style.scrollPaddingBottom;
    html.style.scrollPaddingTop = `${paddingTop}vh`;
    html.style.scrollPaddingBottom = `${paddingBottom}vh`;

    return () => {
      html.style.scrollPaddingTop = prevScrollPaddingTop;
      html.style.scrollPaddingBottom = prevScrollPaddingBottom;
    };
  }, [paddingTop, paddingBottom]);
};
